<template>
  <div>
    <div class="center" v-if="showLoading">
      <lottie :options="defaultOptionsLoading" :height="300" :width="300" v-on:animCreated="handleAnimationLoading"/>
    </div>
    <div class="newyear" v-else>
      <!-- Header: Logo + Coin + Avatar -->
      <div style="position: absolute; left: 16px; top: 16px; display: flex; flex-direction: row; right: 16px; z-index: 10;">
        <div>
          <img
            src="../assets/images/logo2.png"
            loading="lazy"
            style="height:100px;"
          />
        </div>
        <div style="display: flex; flex: 1; align-items: center; flex-end; justify-content: flex-end;">
          <div style="display: flex; align-items: center; gap: 8px; padding: 8px 16px; background: rgba(255, 107, 53, 0.15); border: 1px solid rgba(255, 107, 53, 0.4); border-radius: 50px; backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);">
                  <img src="../assets/images/coin.png" width="22" alt="Coin" />
                  <span style="font-family: 'Poppins', sans-serif; font-size: 14px; font-weight: 700; color: #FF9165; text-shadow: 0 0 10px rgba(255, 145, 101, 0.5);">{{ mycoin }}</span>
                </div>
                <span class="avatar" id="avatar" :style="{ 'background-image': `url(${pictureUrl})` }"></span>
        </div>
      </div>

      <!-- Main Content -->
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center; width: 100%;">

        <!-- Countdown Timer (ก่อนเวลาเริ่ม) -->
        <div v-if="eventStatus === 'before'" class="countdown-container">
          <h2 class="glow-text">Countdown to 2026</h2>
          <div class="countdown-timer">
            <div class="time-box">
              <span class="time-value">{{ countdown.hours }}</span>
              <span class="time-label">ชั่วโมง</span>
            </div>
            <span class="time-separator">:</span>
            <div class="time-box">
              <span class="time-value">{{ countdown.minutes }}</span>
              <span class="time-label">นาที</span>
            </div>
            <span class="time-separator">:</span>
            <div class="time-box">
              <span class="time-value">{{ countdown.seconds }}</span>
              <span class="time-label">วินาที</span>
            </div>
          </div>
          <p class="event-info">กิจกรรมเริ่ม 23:30 น. - 00:30 น.</p>
        </div>

        <!-- Event Active (กดรับได้) -->
        <div v-else-if="eventStatus === 'active'">
          <!-- CSS Fireworks Background -->
          <div class="fireworks-container">
            <div class="firework"></div>
            <div class="firework"></div>
            <div class="firework"></div>
            <div class="firework"></div>
            <div class="firework"></div>
          </div>

          <!-- Happy New Year 2026 Animation -->
          <div style="position: relative; z-index: 2;">
            <lottie :options="defaultOptionsFirework" :height="150" :width="300" v-on:animCreated="handleAnimationFirework"/>
          </div>

          <!-- Gift Box -->
          <div style="position: relative; z-index: 5; cursor: pointer;">
            <div @click="claimReward" style="position: absolute; left: 50%; transform: translateX(-50%);">
              <lottie :options="defaultOptionsOpenBox" :height="250" :width="250" v-on:animCreated="handleAnimationOpenBox"/>
            </div>
            <div @click="claimReward">
              <lottie :options="defaultOptionsBox" :height="250" :width="250" v-on:animCreated="handleAnimationBox"/>
            </div>
          </div>

          <h2 class="glow-text" style="margin-top: 20px;">Happy New Year 2026!</h2>
          <p v-if="!claimed && canClaim" class="tap-text">แตะเพื่อรับของขวัญ 20 Coin</p>
          <p v-else-if="claimed" class="success-text">คุณได้รับ 20 Coin แล้ว!</p>
          <p v-else class="already-text">คุณรับของขวัญไปแล้วค่ะ</p>
        </div>

        <!-- Event Ended (หมดเวลา) -->
        <div v-else-if="eventStatus === 'after'" class="ended-container">
          <h2 class="glow-text">Happy New Year 2026!</h2>
          <p class="ended-text">กิจกรรมสิ้นสุดแล้วค่ะ</p>
          <p class="ended-text">ขอบคุณที่ร่วมกิจกรรม</p>
        </div>
      </div>

      <!-- Footer Status -->
      <div style="position: absolute; bottom: 20px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
        <div style="display: flex; flex: 1; align-items: center; justify-content: center;">
          <div style="border-radius: 50px; margin-left: 0px; background: rgba(0,0,0,0.5); align-items: center; justify-content: center; display: flex; padding-left: 16px; padding-right: 16px; padding-top: 9px; padding-bottom: 9px;">
            <span class="glow" ref="myBtn">
              {{ statusText }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/database";
import "firebase/firestore";
import moment from "moment-timezone";
import router from "./../router";
import Lottie from './lottie.vue';
import { loadAnimation } from '@/services/lottieLoader';
import liffService from "@/services/liff";

// เสียงพลุ/เฉลิมฉลอง
const celebrateAudio = new Audio(require('../assets/chinese.mp3'));

export default {
  name: "NewYear2026",
  async created() {
    document.body.style.backgroundColor = '#0a0a2e';

    const [animateBox, animateOpenBox, animateFirework, animateLoading] = await Promise.all([
      loadAnimation('Coins_Box'),
      loadAnimation('open_coins_box5'),
      loadAnimation('HAPPY NEW YEAR 2026'),
      loadAnimation('Happy New Year')
    ]);

    this.defaultOptionsBox = { animationData: animateBox, autoplay: true, loop: true };
    this.defaultOptionsOpenBox = { animationData: animateOpenBox, autoplay: false, loop: false };
    this.defaultOptionsFirework = { animationData: animateFirework, autoplay: true, loop: true };
    this.defaultOptionsLoading = { animationData: animateLoading, autoplay: true, loop: true };
  },
  mounted() {
    // LIFF is already initialized by router guard
    this.loadUserData();
    this.startCountdownTimer();
  },
  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  },
  components: {
    'lottie': Lottie
  },
  data() {
    return {
      showLoading: true,
      displayName: "",
      userId: "",
      pictureUrl: "",
      statusMessage: "",
      mycoin: 0,
      userKey: '',

      // Event state
      eventStatus: 'before', // 'before', 'active', 'after'
      canClaim: false,
      claimed: false,
      isProcessing: false, // ป้องกันกดซ้ำ
      statusText: 'กำลังโหลด...',

      // Countdown
      countdown: {
        hours: '00',
        minutes: '00',
        seconds: '00'
      },
      countdownInterval: null,

      // Animation options
      defaultOptionsBox: null,
      defaultOptionsOpenBox: null,
      defaultOptionsFirework: null,
      defaultOptionsLoading: null,

      // Animation refs
      animBox: null,
      animOpenBox: null,
      animFirework: null,
      animLoading: null,

      // Event times - PRODUCTION MODE
      eventStart: moment.tz("2025-12-31 23:30:00", "Asia/Bangkok"),
      eventEnd: moment.tz("2026-01-01 00:30:00", "Asia/Bangkok"),

      // Reward
      rewardAmount: 20
    };
  },
  methods: {
    handleAnimationBox(anim) {
      this.animBox = anim;
    },
    handleAnimationOpenBox(anim) {
      this.animOpenBox = anim;
    },
    handleAnimationFirework(anim) {
      this.animFirework = anim;
    },
    handleAnimationLoading(anim) {
      this.animLoading = anim;
    },

    startCountdownTimer() {
      this.updateCountdown();
      this.countdownInterval = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    },

    updateCountdown() {
      const now = moment().tz("Asia/Bangkok");

      if (now.isBefore(this.eventStart)) {
        // ก่อนเวลาเริ่ม - แสดง countdown
        this.eventStatus = 'before';
        const diff = moment.duration(this.eventStart.diff(now));
        this.countdown.hours = String(Math.floor(diff.asHours())).padStart(2, '0');
        this.countdown.minutes = String(diff.minutes()).padStart(2, '0');
        this.countdown.seconds = String(diff.seconds()).padStart(2, '0');
        this.statusText = 'รอกิจกรรมเริ่ม...';
      } else if (now.isAfter(this.eventEnd)) {
        // หมดเวลา
        this.eventStatus = 'after';
        this.statusText = 'กิจกรรมสิ้นสุดแล้ว';
        if (this.countdownInterval) {
          clearInterval(this.countdownInterval);
        }
      } else {
        // อยู่ในช่วงเวลา
        this.eventStatus = 'active';
        if (this.canClaim && !this.claimed) {
          this.statusText = 'แตะกล่องเพื่อรับของขวัญ!';
        }
      }
    },

    async claimReward() {
      // ป้องกันกดซ้ำ - เช็คทั้ง isProcessing และ claimed
      if (!this.canClaim || this.claimed || this.isProcessing) {
        return;
      }

      // Lock ทันทีก่อนทำงาน
      this.isProcessing = true;

      try {
        // เช็คซ้ำอีกครั้งจาก Firestore ก่อนบันทึก (double-check)
        const existingDoc = await firebase.firestore()
          .collection('newyear2026')
          .doc(this.userId)
          .get();

        if (existingDoc.exists) {
          this.claimed = true;
          this.canClaim = false;
          this.statusText = 'คุณรับของขวัญไปแล้วค่ะ 🎁';
          this.isProcessing = false;
          return;
        }

        // หยุดและซ่อน animation กล่องปิด แล้วแสดงและเล่น animation กล่องเปิด
        this.animBox.stop();
        this.animBox.hide();
        this.animOpenBox.show();
        this.animOpenBox.play();

        // เล่นเสียง
        celebrateAudio.volume = 0.7;
        celebrateAudio.play();

        // Mark as claimed
        this.claimed = true;

        // บันทึกลง Firestore
        await firebase.firestore().collection('newyear2026').doc(this.userId).set({
          userId: this.userId,
          displayName: this.displayName,
          createdate: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          value: this.rewardAmount
        });

        // อัพเดท coins ใน Realtime Database
        const currentCoins = this.mycoin || 0;
        await firebase.database().ref(`/users/${this.userKey}`).update({
          coins: currentCoins + this.rewardAmount
        });

        this.mycoin = currentCoins + this.rewardAmount;
        this.statusText = 'สุขสันต์วันปีใหม่ 2026!';

        // แสดง popup หลังจาก animation เล่นไประยะหนึ่ง (2 วินาที)
        setTimeout(() => {
          this.$confirm({
            message: `🐴✨ ปีมะเมีย 2026 มาถึงแล้ว!\n🎆 ขอให้โชคดี มีชัย ก้าวหน้า\n💰 เงินไหลเข้าไม่หยุด!\nคุณได้รับ ${this.rewardAmount} Coin 🎁`,
            button: {
              yes: 'ขอบคุณค่ะ'
            },
            callback: async (confirm) => {
              if (confirm) {
                this.sendMessageLine(`🐴 สวัสดีปีมะเมีย 2026! 🎆\nขอให้โชคดี ร่ำรวย ก้าวหน้า!\nได้รับ ${this.rewardAmount} Coin 🎁`);
              }
            }
          });
        }, 2000);

      } catch (error) {
        console.error('Error claiming reward:', error);
        this.statusText = 'เกิดข้อผิดพลาด กรุณาลองใหม่';
        this.claimed = false;
        this.isProcessing = false; // ปลด lock เพื่อให้ลองใหม่ได้
      }
    },

    async sendMessageLine(text) {
      try {
        await window.liff.sendMessages([
          {
            "type": "text",
            "text": "🎊 " + text,
          },
        ]);
        window.liff.closeWindow();
      } catch (error) {
        console.error('Error sending LINE message:', error);
      }
    },

    async checkAlreadyClaimed() {
      try {
        const doc = await firebase.firestore().collection('newyear2026').doc(this.userId).get();
        return doc.exists;
      } catch (error) {
        console.error('Error checking claim status:', error);
        return false;
      }
    },

    async loadUserData() {
      // Get profile from centralized service (already fetched by router guard)
      const profile = liffService.profile;
      if (!profile) return;

      this.userId = profile.userId || "";
      this.pictureUrl = profile.pictureUrl || "none";
      if (!window.liff.isInClient()) {
        router.replace("/login");
        return;
      }

      try {
        this.displayName = profile.displayName || "none";
        this.statusMessage = profile.statusMessage || "none";

        if (this.userId) {
          // ดึงข้อมูล user จาก database
          const userSnapshot = await firebase.database()
            .ref(`/users`)
            .orderByChild('userId')
            .equalTo(this.userId)
            .once("value");

          const user = userSnapshot.val();

          if (user) {
            const u = user[Object.keys(user)[0]];
            this.mycoin = u.coins || 0;
            this.userKey = Object.keys(user)[0];

            // ตรวจสอบว่ารับไปแล้วหรือยัง
            const alreadyClaimed = await this.checkAlreadyClaimed();

            if (alreadyClaimed) {
              this.canClaim = false;
              this.statusText = 'คุณรับของขวัญไปแล้วค่ะ 🎁';
            } else {
              this.canClaim = true;
              if (this.eventStatus === 'active') {
                this.statusText = 'แตะกล่องเพื่อรับของขวัญ!';
              }
            }
          } else {
            router.replace("/register");
          }
        }

        // ซ่อน loading และซ่อน animation กล่องเปิดตอนเริ่มต้น
        setTimeout(() => {
          this.showLoading = false;
          // ซ่อน animation กล่องเปิดตอนเริ่มต้น (รอให้ animOpenBox ถูก assign แล้ว)
          setTimeout(() => {
            if (this.animOpenBox) {
              this.animOpenBox.hide();
            }
          }, 100);
        }, 1500);

      } catch (error) {
        console.error('Error getting user profile:', error);
        this.statusText = 'เกิดข้อผิดพลาด';
      }
    },

  }
};
</script>

<style scoped>
.newyear {
  padding: 0px;
  margin: 0px;
  overflow: hidden;
  height: 100%;
  width: 100%;
  position: absolute;
  background: linear-gradient(135deg, #0a0a2e 0%, #1a1a4e 50%, #2d1b4e 100%);
  border-right: 2px solid #cbcbcb;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: linear-gradient(135deg, #0a0a2e 0%, #1a1a4e 50%, #2d1b4e 100%);
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
}

.glow {
  color: #fff;
  text-align: center;
  animation: glow 1s ease-in-out infinite alternate;
}

.glow-text {
  color: #ffd700;
  font-size: 28px;
  font-weight: bold;
  text-shadow: 0 0 10px #ffd700, 0 0 20px #ffd700, 0 0 30px #ffa500;
  margin: 10px 0;
}

.countdown-container {
  padding: 20px;
}

.countdown-timer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin: 20px 0;
}

.time-box {
  background: rgba(255, 215, 0, 0.2);
  border: 2px solid #ffd700;
  border-radius: 10px;
  padding: 15px 20px;
  min-width: 70px;
}

.time-value {
  display: block;
  font-size: 36px;
  font-weight: bold;
  color: #ffd700;
  text-shadow: 0 0 10px #ffd700;
}

.time-label {
  display: block;
  font-size: 12px;
  color: #fff;
  margin-top: 5px;
}

.time-separator {
  font-size: 36px;
  color: #ffd700;
  font-weight: bold;
}

.event-info {
  color: #fff;
  font-size: 14px;
  opacity: 0.8;
}

.tap-text {
  color: #fff;
  font-size: 18px;
  animation: pulse 1.5s ease-in-out infinite;
}

.success-text {
  color: #4ade80;
  font-size: 20px;
  font-weight: bold;
}

.already-text {
  color: #fbbf24;
  font-size: 16px;
}

.ended-container {
  padding: 20px;
}

.ended-text {
  color: #fff;
  font-size: 16px;
  opacity: 0.8;
}

@keyframes glow {
  from {
    text-shadow: 0 0 10px #ffd700, 0 0 20px #ffd700, 0 0 30px #ffd700;
  }
  to {
    text-shadow: 0 0 20px #ffd700, 0 0 30px #ffd700, 0 0 40px #ffd700;
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.05);
  }
}

/* CSS Fireworks Animation */
.fireworks-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  overflow: hidden;
}

.firework {
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  animation: firework 2s ease-out infinite;
}

.firework:nth-child(1) {
  left: 10%;
  animation-delay: 0s;
  background: #ff6b6b;
  box-shadow:
    0 0 20px #ff6b6b,
    20px -30px 0 #ffd700,
    -20px -30px 0 #00ff88,
    30px 0 0 #ff69b4,
    -30px 0 0 #00bfff,
    20px 30px 0 #ffa500,
    -20px 30px 0 #ff1493;
}

.firework:nth-child(2) {
  left: 30%;
  animation-delay: 0.4s;
  background: #ffd700;
  box-shadow:
    0 0 20px #ffd700,
    25px -25px 0 #ff6b6b,
    -25px -25px 0 #00bfff,
    35px 0 0 #00ff88,
    -35px 0 0 #ff69b4,
    25px 25px 0 #ff1493,
    -25px 25px 0 #ffa500;
}

.firework:nth-child(3) {
  left: 50%;
  animation-delay: 0.8s;
  background: #00ff88;
  box-shadow:
    0 0 20px #00ff88,
    22px -28px 0 #ffd700,
    -22px -28px 0 #ff6b6b,
    32px 0 0 #00bfff,
    -32px 0 0 #ffa500,
    22px 28px 0 #ff69b4,
    -22px 28px 0 #ff1493;
}

.firework:nth-child(4) {
  left: 70%;
  animation-delay: 1.2s;
  background: #00bfff;
  box-shadow:
    0 0 20px #00bfff,
    18px -32px 0 #ff69b4,
    -18px -32px 0 #ffd700,
    28px 0 0 #ff6b6b,
    -28px 0 0 #00ff88,
    18px 32px 0 #ffa500,
    -18px 32px 0 #ff1493;
}

.firework:nth-child(5) {
  left: 90%;
  animation-delay: 1.6s;
  background: #ff69b4;
  box-shadow:
    0 0 20px #ff69b4,
    24px -26px 0 #00ff88,
    -24px -26px 0 #00bfff,
    34px 0 0 #ffd700,
    -34px 0 0 #ff6b6b,
    24px 26px 0 #ff1493,
    -24px 26px 0 #ffa500;
}

@keyframes firework {
  0% {
    transform: translateY(100vh) scale(0);
    opacity: 1;
  }
  50% {
    transform: translateY(30vh) scale(1);
    opacity: 1;
  }
  100% {
    transform: translateY(30vh) scale(1.5);
    opacity: 0;
  }
}
</style>
